import { configureStore } from '@reduxjs/toolkit'
import builderReducer from './pagebuilder/PageBuilderSlice'
import renderReducer from './pageRender/pageRenderSlice'
import previewReducer from './pageRender/pagePreviewSlice'
import footerReducer from './pageRender/footerSlice'
import headerReducer from './pageRender/headerSlice'
import rentmyReducer from './rentmy/rentmySlice'
import copyReducer from './slice/copySlice'
import copyColumnReducer from './slice/copyColumnSlice'
import builderSetting from './slice/builderSettingSlice'
import globalSettingsSlice from './slice/globalSettingsSlice'

export const store = configureStore({
    reducer: {
        builder: builderReducer,
        builderSetting: builderSetting,
        globalSettings: globalSettingsSlice,
        render: renderReducer,
        preview: previewReducer,
        footer: footerReducer,
        header: headerReducer,
        rentmy: rentmyReducer,
        copyPaste: copyReducer,
        copyPasteColumn: copyColumnReducer,
    },
})